import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import moment from "moment";
import {
  tourBookingTravellers,
  tourLanguages,
  tourPassengerMix,
} from "../../../controllers/tourUIController";
import { capitalize } from "lodash";

function TourVoucherTicketHeaderStatic(booking) {
  const [barcodeBase64, setBarcodeBase64] = useState("");

  useEffect(() => {
    const generateBarcode = async () => {
      const ref = booking?.itemRef?.replace("BR-", "");
      if (!ref) return;

      const response = await fetch(
        `https://bwipjs-api.metafloor.com/?bcid=code128&text=${encodeURIComponent(
          ref
        )}&scale=3`
      );
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        setBarcodeBase64(reader.result);
      };
      reader.readAsDataURL(blob);
    };

    if (booking?.itemRef) {
      generateBarcode();
    }
  }, [booking]);

  if (!booking || !barcodeBase64) return "";

  const packageName = () => {
    if (
      !booking?.requestBody?.items?.at(0)?.productOptionCode ||
      !booking?.extraDetails?.productInfo?.productOptions
    ) {
      return booking?.extraDetails?.productInfo?.title;
    }
    let selected = booking?.extraDetails?.productInfo?.productOptions?.find(
      (option) =>
        option?.productOptionCode ===
        booking?.requestBody?.items?.at(0)?.productOptionCode
    )?.title;
    return selected;
  };

  const passengers = tourBookingTravellers({ booking });

  const items = [
    [
      {
        title: "Date & time",
        value: `${moment(booking?.travelDate).format("ddd, MMM DD, YYYY")} ${
          booking?.startTime
            ? `• ${moment(booking?.startTime, "HH:mm").format("h:mm a")}`
            : ""
        }`,
      },
      {
        title: "Travellers",
        value: `${passengers?.at(0)?.name} • ${tourPassengerMix({
          item: booking?.holdBookingRes?.items?.at(0),
        })}`,
      },
    ],
    [
      {
        title: "Language",
        value: booking?.extraDetails?.languageGuide
          ? `${tourLanguages({
              tour: { languageGuides: [booking?.extraDetails?.languageGuide] },
            })} - ${capitalize(booking?.extraDetails?.languageGuide?.type)}`
          : "",
      },
      {
        title: "Booking ref.",
        value: booking?.itemRef?.replace("BR-", ""),
      },
    ],
    [
      {
        title: "Activity provider",
        value: booking?.extraDetails?.productInfo?.supplier?.name,
      },
    ],
  ];

  const staticContent = (
    <div className="w-full rounded-xl border-2 border-blue-600 flex overflow-hidden mt-10">
      <div
        className=" bg-blue-600 p-8 flex flex-col"
        style={{ width: "700px", height: "700px" }}
      >
        <h3 className="text-white mb-3 text-9xl font-black">Intraverse.</h3>
        <span className="text-white font-bold text-4xl">
          {booking?.extraDetails?.productInfo?.title}
        </span>
        <small className="text-white mt-2 text-3xl">{packageName()}</small>
      </div>
      <div className="flex flex-1 flex-col p-8 ">
        <div className="w-full flex ">
          <table className="w-full table-fixed !border-none border-collapse">
            <tbody>
              {items?.map((row, rowIndex) => (
                <tr key={rowIndex} className="!border-none">
                  {row?.map((col, colIndex) => (
                    <td key={colIndex} className="w-1/3 align-top !border-none">
                      <div className="flex flex-col mb-4">
                        <small className="text-gray-400 text-2xl">
                          {col.title}
                        </small>
                        <small className="font-bold text-3xl">
                          {col.value}
                        </small>
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex flex-1 flex-col gap-2 items-center justify-center">
          <img src={barcodeBase64} alt="barcode" className="h-44" />
          <small className=" font-bold -mt-1 text-2xl">
            {booking?.itemRef.replace("BR-", "")}
          </small>
        </div>
      </div>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default TourVoucherTicketHeaderStatic;
